import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Header from './components/Header';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';


import Home from './pages/Home';
import Nosotros from './pages/Nosotros';
import Destinos from './pages/Destinos';
import Galeria from './pages/Galeria';
import Contacto from './pages/Contacto';
import DetalleDestino from './pages/DetalleDestino';
import Reserva from './pages/Reserva';
import './pages/Responsivo.css';





function App() {
  return (
    <Router>
      <div className="App">
        {/* Header arriba */}
        <Header />

        {/* Contenido principal */}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/nosotros" element={<Nosotros />} />
          <Route path="/destinos" element={<Destinos />} />
          <Route path="/galeria" element={<Galeria />} />
          <Route path="/contacto" element={<Contacto />} />
          <Route path="/destinos/:id" element={<DetalleDestino />} />
          <Route path="/reserva" element={<Reserva />} />
        </Routes>

        {/* Footer abajo */}
        <WhatsAppButton />

        <Footer />

      </div>
    </Router>
  );
}

export default App;
